export default [
  {
    id: '1-2',
    parentId: '0',
    title: '代办',
    path: '/brands/do-sth',
    type: 2,
    component: '/brands/do-sth/do-sth',
    isHidden: true,
    icon: 'kl-project'
  }
]
